import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { UserManagement } from '../../components/UserManagement'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/pengguna')({
  component: PenggunaPage,
})

function PenggunaPage() {
  const session = useSession()
  const logout = useLogout()
  const user = session.data?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? ''}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <UserManagement />
    </AppShell>
  )
}
